import StopIcon from './stop';

const icons = {
  stop: StopIcon,
};

const getMarkerSrc = (type, color, text) => {
  const svgString = icons[type](color, text);

  return `data:image/svg+xml;charset=utf-8;base64,${btoa(
    decodeURIComponent(encodeURIComponent(svgString)),
  )}`;
};

export default getMarkerSrc;
